<template>
  <div>
    <div class="copyright">
      <img src="../assets/vgp-logo-simple.png" alt="" srcset="" />
      <div class="copyright__content">
        Công ty CP VGP phân phối độc quyền tại Việt Nam.
      </div>
    </div>
    <v-footer class="footer" padless fixed>
      <v-container class="pt-0 pb-0">
        <div class="footer__menu">
          <v-row class="footer__row pt-0 pb-0">
            <v-col
              cols="3"
              v-for="(link, index) in links"
              :key="index"
              class="footer__col"
            >
              <router-link
                :to="link.src"
                :href="link.src"
                class="footer__link white--text"
              >
                <img
                  class="d-block text-center ma-auto"
                  :src="link.icon"
                  alt=""
                  srcset=""
                />
                <span class="footer__title">{{ link.name }}</span>
              </router-link>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-footer>
  </div>
</template>

<script>
import homeCircle from '../assets/icons/home-circle.svg'
import gift from '../assets/icons/gift.svg'
import coin from '../assets/icons/coin.svg'
import support from '../assets/icons/support-ft.svg'

export default {
  name: 'Footer',
  data: () => ({
    links: [
      {
        icon: homeCircle,
        name: 'Trang chủ',
        src: '/',
      },
      {
        icon: gift,
        name: 'Đổi code',
        src: '/giftcode?tab=doi-code',
      },
      {
        icon: coin,
        name: 'Nạp thẻ',
        src: '/napvgplay',
        href: 'https://www.nap.vgplay.vn',
      },
      {
        icon: support,
        name: 'Hỗ trợ',
        src: '/support',
        href: '',
      },
    ],
  }),
}
</script>

<style lang="scss" scoped></style>
